import Appbar from 'components/appbar/Appbar';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import React from 'react';
import PackageAction from './PackageAction';
import { useFetchPackages } from './hooks/useFetchPackages';
import PackageFilterBox from './PackageFilterBox';
import Pagination from 'components/pagination/Pagination';
import NoData from 'components/no-data/NoData';
import TableLoading from 'components/loading/TableLoading';
import PaginationProvider from 'hooks/pagination';
import ModuleLoading from 'components/loading/ModuleLoading';
import { useDisplayMode } from 'hooks/useDisplayMode';
import PackageListTable from './list/table/PackageListTable';
import PackageListModule from './list/module/PackageListModule';

const Package: React.FC = () => {
  const {
    packages,
    loading,
    orderedIndex,
    handleSort,
    filter,
    handleChange,
    setPage,
    setRows,
    handleSearch,
    page,
    rows,
    total,
  } = useFetchPackages();
  const [displayMode] = useDisplayMode();
  return (
    <>
      <Appbar title="Pacotes" ActionsComponent={<PackageAction />} />
      <PageHeaderActions
        title="Pacotes"
        description="Gestão de pacotes de produtos"
        ActionComponent={<NewRecordButton label="Novo pacote" to="/packages/new" />}
      />

      <PackageFilterBox filter={filter} handleChange={handleChange} handleSearch={handleSearch} loading={loading} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : packages.length === 0 ? (
          <NoData message="Nenhum pacote encontrado" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <PackageListTable packages={packages} />
            ) : (
              <PackageListModule handleSearch={handleSearch} packages={packages} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Package;
